
import { CountryCodes } from "../constants/countries";

class MaskedFormat {
    public readonly maskedInput = {
        postalCode: {
            NONE: {
                mask: [],
                placeHolder: ""
            },
            CA: {
                mask: [/[A-Za-z]/, /\d/, /[A-Za-z]/, ' ', /\d/, /[A-Za-z]/, /\d/],
                placeHolder: "A1A 1A1"
            },
            US: {
                mask: [/\d/, /\d/, /\d/, /\d/, /\d/],
                placeHolder: "11111"
            },
            MX: {
                mask: [/\d/, /\d/, /\d/, /\d/, /\d/],
                placeHolder: "11111"
            },
            CO: {
                mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
                placeHolder: "111111"
            }
        },
        phoneNumber: {
            NONE: {
                mask: [],
                placeHolder: ""
            },
            CA: {
                mask: ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
                placeHolder: "+1 (___) ___-____"
            },
            US: {
                mask: ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
                placeHolder: "+1 (___) ___-____"
            },
            MX: {
                mask: ['+', '5', '2', ' ', '(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
                placeHolder: ['+52 (__) ____-____']
            },
            CO: {
                mask: ['+', '5', '2', ' ', '(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
                placeHolder: ['+57 (__) ____-____']
            }
        },
        healthCardNumbers: {
            CA: {
                QC: {
                    placeHolder: "____ ____ ____",
                    regExp: /^([A-Z]{4})([0-9]{8})/,
                    textMask: "AAAA 1111 1111"
                },
                NB: {
                    regExp: /^([0-9]{3})([0-9]{3}([0-9]{3}))/,
                    textMask: "111-111-111",
                    placeHolder: "___-___-___",
                },
                ON: {
                    regExp: /^([0-9]{4})([0-9]{3})([0-9]{3})([A-Z]{2})/,
                    textMask: "1111-111-111-AA",
                    placeHolder: "____-___-___-__",
                }
            },
            MX: {
                placeHolder: "__________________",
                regExp: /^([A-Z]{4})([0-9]{6})([A-Z]{6})([0-9]{2})/,
                textMask: "AAAA111111AAAAAA11"
            }
        }
    }

    public convertRawNumberToCountryPhoneNumberView(phoneNumber: string, country: string): string {
        if (phoneNumber && phoneNumber.length === 10)
        {
            switch (country) {
                case CountryCodes.CA:
                    return "+1 (" + phoneNumber.substr(0, 3) + ") " + phoneNumber.substr(3, 3) + "-" + phoneNumber.substr(6, 4);
                case CountryCodes.US:
                    return "+1 (" + phoneNumber.substr(0, 3) + ") " + phoneNumber.substr(3, 3) + "-" + phoneNumber.substr(6, 4);
                case CountryCodes.MX:
                    return "+52 (" + phoneNumber.substr(0, 3) + ") " + phoneNumber.substr(3, 3) + "-" + phoneNumber.substr(6, 4);
                case CountryCodes.CO:
                    return "+57 (" + phoneNumber.substr(0, 3) + ") " + phoneNumber.substr(3, 3) + "-" + phoneNumber.substr(6, 4);
                default:
                    return "";
            }
        }
        return "";
    }

    public getCountryRegionCodePlaceHolder(country: CountryCodes) {
        if (this.maskedInput.postalCode[country]) {
            return this.maskedInput.postalCode[country].placeHolder;
        }
        return "";
    }
}
export default new MaskedFormat;


// WEBPACK FOOTER //
// ./src/services/MaskedFormat.ts